var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM7 11.49C7 9.664 8.4685 7.5025 11.4 5C14.3315 7.5025 15.8 9.664 15.8 11.49C15.8 14.229 13.71 16 11.4 16C9.09 16 7 14.229 7 11.49ZM9.5135 11.941C9.475 11.743 9.31 11.6 9.1065 11.6C9.04676 11.6 8.98774 11.613 8.93352 11.6381C8.8793 11.6632 8.83118 11.6997 8.79247 11.7452C8.75377 11.7907 8.72541 11.8441 8.70936 11.9017C8.69331 11.9592 8.68994 12.0195 8.6995 12.0785C9.013 13.745 10.3825 14.416 11.554 14.3445C11.774 14.3335 11.95 14.152 11.95 13.932C11.95 13.6955 11.752 13.5085 11.5155 13.5195C10.7675 13.58 9.739 13.162 9.5135 11.941Z",
    fill: "#E64011"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotWater);
export default __webpack_public_path__ + "static/media/hotWater.678873c6992e74ac29b1133cb015b901.svg";
export { ForwardRef as ReactComponent };